import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';

function TrackingPage() {
  const [trackingId, setTrackingId] = useState("");
  const [result, setResult] = useState(null);
  const navigate = useNavigate();

  const handleTrack = () => {
    if (!trackingId.trim()) {
      return;
    }
     navigate(`/track?id=${trackingId.trim()}`);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="bg-white shadow-lg rounded-2xl p-6 w-full max-w-md">

        <h2 className="text-xl font-semibold mb-4 text-center">
          Track Your Shipment
        </h2>

        <div className="flex">
          <input
            type="text"
            placeholder="Enter AWB / Order ID"
            value={trackingId}
            onChange={(e) => setTrackingId(e.target.value)}
            className="flex-1 p-2 border rounded-l-lg focus:outline-none"
          />

          <button
            onClick={handleTrack}
            className="bg-blue-600 text-white px-4 rounded-r-lg"
          >
            Track
          </button>
        </div>
      </div>
    </div>
  );
}

export default TrackingPage;